export default __webpack_public_path__ + "static/media/whatsapp_cart_icon.f0931012.svg";